import { useGesture } from '@use-gesture/react';

export default function useNoGestures(ref: any) {
	useGesture(
		{
			// our onWheel setup is screened to allow scrolling, but *not* left/right
			// swipes, so that the user can scroll up/down normally but *not* navigate back to the
			// previous page by swiping
			// in the options, we set passive to false to tell the system "hey, don't just process
			// the event using default browser behavior, let this javascript fire first"
			// we set axis to 'x' so that horizontal gestures get sent to our onWheel handler
			// (however vertical gestures such as scrolling do *not* get sent to our handler,
			// resulting in default vertical scroll behavior)
			// in our onWheel, we preventDefault on the horizontal gestures we receive, canceling the
			// browser back/fwd navigation
			onWheel: ({ event }) => {
				// Make one exception to allow scrolling in the code editor to work correctly.
				if (event.target instanceof Element && event.target.closest('.cm-editor')) return;

				event.preventDefault();
			},
			// disables trackpad gestures (pinch swipe) on the provided ref, along with
			// sometimes mouse equivalents like modifierkey+wheel
			onPinch: ({ event }) => {
				event.preventDefault();
			},
		},
		{
			target: ref,
			wheel: { eventOptions: { passive: false }, axis: 'x' },
		}
	);
}
